/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningssortgross2Inputs */

const en_earningssortgross2 = /** @type {(inputs: Earningssortgross2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenue`)
};

const de_earningssortgross2 = /** @type {(inputs: Earningssortgross2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umsatz`)
};

/**
* | output |
* | --- |
* | "Revenue" |
*
* @param {Earningssortgross2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningssortgross2 = /** @type {((inputs?: Earningssortgross2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningssortgross2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningssortgross2(inputs)
	return de_earningssortgross2(inputs)
});
export { earningssortgross2 as "earningsSortGross" }